import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
import VueSweetalert2 from 'vue-sweetalert2'
import 'firebase'
import VueFire from 'vuefire'
import VueFirestore from 'vue-firestore'
import VueMoment from 'vue-moment'

import Nav from './components/Nav.vue'
import HeaderHome from './components/HeaderHome.vue'
import Happy from './components/Happy.vue'
import SocialIcons from './components/SocialIcons.vue'
import Hamburger from './components/Hamburger.vue'
import NewsletterSignup from './components/NewsletterSignup.vue'
import Testimonials from './components/Testimonials.vue'
import Packages from './components/Packages.vue'
import PackagesSignup from './components/PackagesSignup.vue'
import BlogArticles from './components/BlogArticles.vue'
import Juicer from './components/Juicer.vue'
import BookingSignup from './components/BookingSignup.vue'
import SiteMap from './components/SiteMap.vue'
import Footer from './components/Footer.vue'
import Modal from './components/Modal.vue'


// **PAGES**
import Home from './components/Home.vue'
import AboutPage from './components/AboutPage.vue'
import TestimonialsPage from './components/TestimonialsPage.vue'
import CoachingPage from './components/CoachingPage.vue'
import BlogPage from './components/BlogPage.vue'
import ContactPage from './components/ContactPage.vue'
import AboutPageHeader from './components/AboutPageHeader.vue'
import ContactsViewer from './components/ContactsViewer.vue'
import BlogPostOne from './components/BlogPostOne.vue'
import BlogPostTwo from './components/BlogPostTwo.vue'

// import BlogHome from './components/BlogHome'
// import BlogPost from './components/BlogPost'
// import Butter from 'buttercms'

Vue.use(VueRouter);
Vue.use(VueSweetalert2);
// Vue.use(VueFire)
Vue.use(VueFirestore);
Vue.use(VueMoment);

const router = new VueRouter({
  routes, 
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

Vue.component('nav-component', Nav);
Vue.component('home', Home);
Vue.component('header-home', HeaderHome);
Vue.component('happy', Happy);
Vue.component('social-icons', SocialIcons);
Vue.component('hamburger', Hamburger);
Vue.component('newsletter-signup', NewsletterSignup);
Vue.component('testimonials', Testimonials);	
Vue.component('packages', Packages);
Vue.component('packages-signup', PackagesSignup);
Vue.component('blog-articles', BlogArticles);
Vue.component('juicer', Juicer);
Vue.component('booking-signup', BookingSignup);
Vue.component('site-map', SiteMap);
Vue.component('footer-component', Footer);
Vue.component('modal', Modal);

Vue.component('about-page', AboutPage);
Vue.component('testinomials-page', TestimonialsPage);
Vue.component('coaching-page', CoachingPage);
Vue.component('blog-page', BlogPage);
Vue.component('blog-page-one', BlogPostOne);
Vue.component('blog-page-two', BlogPostTwo);
// Vue.component('blog-home', BlogHome);
// Vue.component('blog-post', BlogPost);

Vue.component('contact-page', ContactPage);

Vue.component('about-page-header', AboutPageHeader);
Vue.component('jackies-contact-viewer', ContactsViewer);




// const butter = Butter('7e6e0cee8eb380372947cef75bd3ea9d3c54017e');

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js